/* Rx Size Guide lightbox — click sulla chart -> <dialog> grande.
   Vanilla JS, zero librerie, zero CDN esterni. Progressive enhancement:
   se <dialog> non e' supportato, l'immagine resta visibile inline (nessuna rottura). */
(function () {
  function build() {
    var imgs = document.querySelectorAll('.rx-size-guide__img');
    if (!imgs.length) return;

    var dlg = document.querySelector('dialog.rx-sg-dialog');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'rx-sg-dialog';
      dlg.innerHTML =
        '<button type="button" class="rx-sg-dialog__close" aria-label="Close">×</button><img alt="">';
      document.body.appendChild(dlg);
      dlg.querySelector('.rx-sg-dialog__close').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }
    var big = dlg.querySelector('img');

    imgs.forEach(function (im) {
      if (typeof dlg.showModal !== 'function') return; // fallback: resta inline
      im.setAttribute('role', 'button');
      im.setAttribute('tabindex', '0');
      function open() {
        big.src = im.currentSrc || im.src;
        big.alt = im.alt || '';
        dlg.showModal();
      }
      im.addEventListener('click', open);
      im.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
    });
  }
  if (document.readyState !== 'loading') build();
  else document.addEventListener('DOMContentLoaded', build);
})();
